import React, { createContext, useContext, useState } from "react";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import Cookies from "js-cookie";
import { io } from "socket.io-client";
// const SOCKET_SERVER_URL = "https://api.flowchanger.com/api/";
// const SOCKET_SERVER_URL = "http://localhost:8000/api/";
const SOCKET_SERVER_URL = "https://fc-production-testing.onrender.com/api/";

export const MainContext = createContext();
export const GlobalContext = ({ children }) => {
  const flowChangerToken = Cookies.get("flowChangerAuthToken");
  const [activeSubmenu, setActiveSubmenu] = useState(false);

  const [selectedSidebarTab, setSelectedSidebarTab] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  // const baseUrl = "https://api.flowchanger.com/api/";
  // const baseUrl = "http://localhost:8000/api/";
  const baseUrl = "https://fc-production-testing.onrender.com/api/";
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState(null);

  const [staffTab, setStaffTab] = useState(0);
  const [name, setName] = useState({ department_name: "" });
  const [depId, setDepId] = useState("");
  const [editPermissions, setEditPermissions] = useState({
    clients_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    projects_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    report_permissions: { view_global: false, view_time_sheets: false },
    staff_role_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    settings_permissions: { view_global: false, view_time_sheets: false },
    staff_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    task_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    sub_task_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    chat_module_permissions: { grant_access: false },
    ai_permissions: { grant_access: false },
  });
  const [roleName, setRoleName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [staffs, setStaffs] = useState([]);
  console.log(staffs)
  const [shift, setShift] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [branchItem, setBranchItem] = useState()
  const [departments, setDepartments] = useState([]);
  const [roles, setRoles] = useState(null);
  console.log(roles);
  // chat section code
  const [socket, setSocket] = useState(null);
  const [messages, setMessages] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [message, setMessage] = useState("");
  const [currRoom, setCurrRoom] = useState(null);
  const [id, setId] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [showChatSection, setShowChatSection] = useState(false);
  const [showAnnouncementsModal, setShowAnnouncementsModal] = useState(false);
  const [showCreateGroupModal, setShowCreateGroupModal] = useState(false);
  const [AddMembersPanel, setShowAddMembersPanel] = useState(false);
  const [showDeleteGroupModal, setShowDeleteGroupModal] = useState(false);
  const [showAddMemberModal, setShowAddMemberModal] = useState(false);
  const [toggleSettings, setToggleSettings] = useState(false);
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [clientData, setClientData] = useState(null);
  const [projectData, setProjectData] = useState(null);
  const [taskData, setTaskData] = useState(null);

  const [totalRecord, setTotalRecord] = useState(0);
  const [clientDetail, setClientDetail] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsToShow, setRowsToShow] = useState(25);
  const [selectedStaff, setSelectedStaff] = useState(null);
  console.log(selectedStaff)
  const [savePaymentData, setSavePaymentData] = useState([]);
  const [selectBranch, setSelectBranch] = useState("");
  const [selectDepartments, setSelectDepartments] = useState("");
  const [attendance, setAttendance] = useState([]);
  const [attendanceTabDepartments, setAttendanceTabDepartments] = useState([]);
  const [fine, setFine] = useState();
  const [overtime, setOverTime] = useState();
  const [summaryDate, setSummaryDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [leads, setleads] = useState(null);
  const [currentleadPage, setCurrentleadPage] = useState(1);
  const [totalleadPage, setTotalleadPage] = useState(1);
  const [totalDepartmentPage, setTotalDepartmentPage] = useState(1);
  const [totalleadRecords, setTotalleadRecords] = useState(0);
  const [pagelead, setleadPage] = useState(1);

  const [page, setPage] = useState(1);
  const [goggleAuthentication, setGoogleAuthentication] = useState(false);

  //  handling the modals in clientchatInterface
  const handleToggleSettings = () => {
    setToggleSettings((toggleSettings) => !toggleSettings);
  };

  const handleAddMembersPanel = () => {
    setShowAddMembersPanel((AddMembersPanel) => !AddMembersPanel);
  };
  const handleAddMembersModal = () => {
    setShowAddMemberModal((showAddMemberModal) => !showAddMemberModal);
  };

  const handleAnnouncementsClick = () => {
    setShowAnnouncementsModal(true);
    setToggleSettings(false); // Close the settings menu when opening modal
  };
  const handleCreateGroupClick = () => {
    setShowCreateGroupModal(true);
    setToggleSettings(false); // Close the settings menu when opening modal
  };
  const handleDeleteGroupClick = () => {
    setShowDeleteGroupModal(true);
    // Close the settings menu when opening modal
  };

  const handleChangeBranch = (value) => {
    setSelectBranch(value);
    console.log(value);
  };

  const handleChangeDepartment = (value) => {
    setSelectDepartments(value);
  };

  const resetState = () => {
    setSelectBranch("");
    setSelectDepartments("");
  };

  useEffect(() => {
    if (Cookies.get("flowChangerAuthToken")) {
      const socketInstance = io(SOCKET_SERVER_URL);
      setSocket(socketInstance);

      socketInstance.on("connect", () => {
        socketInstance.emit("setup", {
          token: Cookies.get("flowChangerAuthToken"),
        });
      });

      return () => {
        socketInstance.disconnect();
      };
    }
  }, []);
  useEffect(() => {
    if (socket) {
      socket.on("message_received", (data) => {
        if (currRoom && data.roomId === currRoom.id) {
          setMessages((prevMessages) => [...(prevMessages || []), data]);
        } else {
          console.log("new notification", data.sender.id);
          setNotifications((prevNotifications) =>
            prevNotifications.includes(data.sender.id)
              ? prevNotifications
              : [...prevNotifications, data.sender.id]
          );
        }
      });
    }

    return () => {
      if (socket) socket.off("message_received");
    };
  }, [socket, currRoom]);

  const fetchOneOnOneChat = async (id) => {
    try {
      const response = await fetch(`${baseUrl}chat/${id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      console.log(response);
      if (!response.status == 200) {
        openToast(`Failed to fetch chat`, "error");
      } else {
        const room = await response.json();
        socket.emit("join_room", room.id);
        setCurrRoom(room);
        setId(room.userId);
        setMessages(room.messages ?? []);
      }
    } catch (error) {
      console.log(error);
      openToast("Something went wrong", "error");
    }
  };

  const sendMessage = async () => {
    try {
      setIsSendingMessage(true);
      if (message != "") {
        console.log(message, currRoom.id);
        const response = await fetch(`${baseUrl}message/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
          body: JSON.stringify({ content: message, roomId: currRoom.id }),
        });

        if (!response.status == 200) {
          openToast(`${(await response.json()).error}`, "error");
        } else {
          const { message, room, users } = await response.json();
          setMessages([...messages, message]);
          socket.emit("send_message", {
            message: message,
            room: room,
            users: users,
          });
        }
        setMessage("");
      }
    } catch (error) {
      openToast("Something went wrong", "error");
    } finally {
      setIsSendingMessage(false);
    }
  };
  const handleSelectedUser = (user) => {
    if (notifications.includes(user.id)) {
      notifications.splice(notifications.indexOf(user.id), 1);
    }
    setSelectedUser(user);
    setMessages(null);
    fetchOneOnOneChat(user.id);
    setShowChatSection(true);
  };
  // chat section code ends here
  const [isLoading, setIsLoading] = useState(false);
  const [selectedStaffIds, setSelectedStaffIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loadingClient, setLoadingClient] = useState(false);
  const [loadingStaffs, setLoadingStaffs] = useState(false);
  const [loadingRole, setLoadingRole] = useState(false);
  const [loadingDepartment, setLoadingDepartment] = useState(false);
  const [loadingBranch, setLoadingBranch] = useState(false);
  const [loadingProject, setLoadingProject] = useState(false);
  const [loadingTask, setLoadingTask] = useState(false);

  const fetchProject = async () => {
    try {
      setLoadingProject(true);
      const token = Cookies.get("flowChangerAuthToken");

      if (!token) {
        console.log("No token found");
        setBranchData([]);
        return;
      }

      const result = await fetch(baseUrl + `project`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!result.ok) {
        throw new Error(`HTTP error! Status: ${result.status}`);
      }

      const data = await result.json();
      setProjectData(data.data);
      console.log(data);
    } catch (error) {
      console.error("Error fetching project:", error);
    } finally {
      setLoadingProject(false);
    }
  };

  const fetchTask = async () => {
    try {
      setLoadingTask(true);
      const token = Cookies.get("flowChangerAuthToken");

      if (!token) {
        console.log("No token found");
        setBranchData([]);
        return;
      }

      const result = await fetch(baseUrl + `task/detail`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!result.ok) {
        throw new Error(`HTTP error! Status: ${result.status}`);
      }

      const data = await result.json();
      setTaskData(data.taskDetail);
      console.log(data);
    } catch (error) {
      console.error("Error fetching task:", error);
    } finally {
      setLoadingTask(false);
    }
  };

  const fetchBranch = async () => {
    if (!Cookies.get("flowChangerAuthToken")) {
      console.log("no token found");
      setBranchData([]);
      return;
    }
    try {
      setLoadingBranch(true);
      const response = await fetch(baseUrl + "branch", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (response.status == 200) {
        const data = await response.json();
        setBranchData(data || []);
      }
    } catch (error) {
      console.log("error");
    } finally {
      setLoadingBranch(false);
    }
  };

  const fetchRoles = async (page = 1) => {
    if (!Cookies.get("flowChangerAuthToken")) {
      setRoles([]);
      return { data: [], totalPages: 1, totalRecords: 0 }
    }
    setLoadingRole(true);
    try {
      const result = await fetch(`${baseUrl}role?page=${page}&limit=10`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });

      if (result.status == 200) {
        const res = await result.json();
        console.log(res)
        setRoles(res.data);
        return {
          data: res.data,
          totalPages: res?.pagination?.totalPages || Math.ceil(res.totalRecords / 10),
          totalRecords: res.totalRoles || res.data.length,
        };

      } else {
        console.log("Failed to fetch department", result.status);
        return { data: [], totalPages: 1, totalRecords: 0 };
      }
    } catch (error) {
      console.log("error:", error);
      return { data: [], totalPages: 1, totalRecords: 0 };
    } finally {
      setLoadingRole(false);
    }
  };

  const fetchStaffs = async (page) => {
    if (!Cookies.get("flowChangerAuthToken")) {
      console.log("No token found");
      setStaffs([]);
      setTotalPages(1);
      setTotalRecords(0);
      setIsLoading(false);
      return;
    }

    try {
      setLoadingStaffs(true);
      const response = await fetch(
        `${baseUrl}staff?page=${page ? page : currentPage}&limit=10`, // Remove the conditional operator
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        console.log(data, "____________-")
        setStaffs(data?.data || []);
        setTotalPages(data?.meta?.totalPages || 1);
        setTotalRecords(data?.meta?.totalRecords || 0);
      } else {
        console.log("Failed to fetch data, status:", response.status);
      }
    } catch (error) {
      console.log("Error fetching staff:", error);
    } finally {
      setLoadingStaffs(false);
    }
  };

  const updatePagination = (page, total, records) => {
    setCurrentPage(page);
    setTotalPages(total);
    setTotalRecords(records);
  };

  const updateStaff = (staff) => setStaffs(staff);

  const fetchShifts = async () => {
    if (!Cookies.get("flowChangerAuthToken")) {
      console.log("no token found");
      setShift([]);
      return;
    }
    try {
      const response = await fetch(baseUrl + "shift", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (response.status == 200) {
        const data = await response.json();
        setShift(data);
        console.log(data);
      }
    } catch (error) {
      openToast("Unable to Fetch Shifts", "error");
    }
  };

  

  const openToast = (msg, flag) => {
    toast(msg, { type: flag });
  };

  const [staffDetail, setStaffDetail] = useState([]);
  const fetchStaff = async () => {
    if (!Cookies.get("flowChangerAuthToken")) {
      console.log("no token found");
      setStaffDetail([]);
      return;
    }
    const result = await fetch(baseUrl + "staff", {
      headers: {
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
      },
    });
    try {
      if (result.status == 200) {
        const res = await result.json();
        console.log(res);
        setStaffDetail(res?.data);
      } else {
        console.log("An Error Occured");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchClientDetail = async () => {
    if (!Cookies.get("flowChangerAuthToken")) {
      setClientData([]);
      return;
    }
    setLoadingClient(true);
    try {
      const result = await fetch(baseUrl + "client", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.status == 200) {
        const res = await result.json();
        setClientData(res?.data);
        setTotalRecord(res?.meta?.totalRecords);
      } else {
        openToast("An Error Occured", "error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingClient(false);
    }
  };
  const fetchDepartments = async (page = 1) => {
    if (!Cookies.get("flowChangerAuthToken")) {
      console.log("No token found");
      return { data: [], totalPages: 1, totalRecords: 0 };
    }

    try {
      const response = await fetch(`${baseUrl}department?page=${page}&limit=10`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });


      if (response.status === 200) {
        const res = await response.json()
        return {
          data: res.data,
          totalPages: res?.pagination?.totalPages || Math.ceil(res.totalRecords / 10),
          totalRecords: res.totalRecords || res.data.length,
        };
      } else {
        console.log("Failed to fetch department", response.status);
        return { data: [], totalPages: 1, totalRecords: 0 };
      }
    } catch (error) {
      console.log("Error while fetching department", error);
      return { data: [], totalPages: 1, totalRecords: 0 };
    }
  };

  const fetchDetail = async () => {
    if (!Cookies.get("flowChangerAuthToken")) {
      setClientDetail([]);
      return;
    }
    setLoadingClient(true);
    try {
      const result = await fetch(
        baseUrl + `client?page=${currentPage}&limit=10`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );

      const res = await result.json();
      if (result.status == 200) {
        setClientDetail(res.data);
        if (res && res.data.length > 0) {
          setIsOpen(true);
        }
        setTotalPages(res?.meta?.totalPages);
        setTotalRecords(res?.meta?.totalRecords);
      } else {
        openToast(res.message);
      }
    } catch (error) {
      openToast(error.message);
    } finally {
      setLoadingClient(false);
    }
  };

  useEffect(() => {
    if (!clientDetail) fetchClientDetail();
  }, []);

  useEffect(() => {
    fetchStaff();
    fetchShifts();
    fetchRoles();
    // fetchClientDetail();
  }, []);

  useEffect(() => {
    if (!clientDetail || clientDetail?.length == 0) {
      fetchDetail();
    }
  }, []);

  useEffect(() => {
    fetchBranch();
  }, []);
  useEffect(() => {
    if (!projectData) {
      fetchProject();
    }
  }, []);
  useEffect(() => {
    if (!taskData) {
      fetchTask();
    }
  }, []);
  useEffect(() => {
    // if (!departments) {
    fetchDepartments();
    // }
  }, []);

  useEffect(() => {
    // if (staffs?.length == 0) {
    fetchStaffs();
    // }
  }, []);

  useEffect(() => {
    if (staffs) {
      fetchStaffs(currentPage, 10);
    }
  }, [currentPage]);

  const handlePrevious = () => {
    if (currentPage <= 1) return; // Prevent API call if on first page

    // Calculate previous page
    const prevPage = currentPage - 1;

    // Update state and fetch data
    setCurrentPage(prevPage);
    fetchStaffs(prevPage); // Pass the calculated prevPage directly
  };

  const handleNext = () => {
    if (currentPage >= totalPages) return; // Prevent API call if already on the last page

    // Don't clear staffs here as it will cause unnecessary flicker
    // Calculate next page
    const nextPage = currentPage + 1;

    // Update state and fetch data
    setCurrentPage(nextPage);
    fetchStaffs(nextPage); // Pass the calculated nextPage directly
  };

  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };

  // aman
  const [searchedStaff, setSearchedStaff] = useState(null);

  const searchStaff = async (value, setIsLoading) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        baseUrl + "staff/search?name=" + value + "&limit=99999",
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );
      if (response.status == 200) {
        const data = await response.json();

        setSearchedStaff(data.data);
      }
    } catch (error) {
      toast("Something went wrong", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const [searchedClient, setSearchedClient] = useState(null);

  const searchClient = async (value) => {
    try {
      const response = await fetch(
        baseUrl + "client/search-by-name?name=" + value + "&limit=99999",
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );
      if (response.status == 200) {
        const data = await response.json();
        setSearchedClient(data.data);
      }
    } catch (error) {
      toast("Something went wrong", "error");
    }
  };


  async function fetchLead(page) {
    setIsLoading(true);
    setTotalleadPage(1);
    setTotalleadPage(0);

    try {
      const response = await fetch(baseUrl + `lead?page=${page}&limit=10`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setleads(data?.leads);
        setTotalleadPage(data.pagination.totalleadPages);
        setTotalleadRecords(data.pagination.totalLeads);
        setTotalleadPage(data.pagination.currentleadPage);
      }
    } catch (error) {
      console.error("Error fetching lead data:", error.message);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    // if (leads == null) {
    fetchLead();

  }, []);

  return (
    <MainContext.Provider
      value={{
        selectedTab,
        searchedClient,
        searchClient,
        searchedStaff,
        searchStaff,
        setSearchedClient,
        setSearchedStaff,
        setSelectedTab,
        staffTab,
        openToast,
        setStaffTab,
        baseUrl,
        name,
        setName,
        fetchStaff,
        depId,
        setDepId,
        roleName,
        setRoleName,
        roleId,
        roles,
        setRoles,
        setRoleId,
        editPermissions,
        setEditPermissions,
        staffs,
        setStaffs,
        fetchStaffs,
        setToggleSettings,
        socket,
        messages,
        setSelectedUser,
        selectedUser,
        setMessages,
        fetchOneOnOneChat,
        message,
        setMessage,
        sendMessage,
        setId,
        id,
        notifications,
        setNotifications,
        handleSelectedUser,
        setShowChatSection,
        showChatSection,
        isSendingMessage,
        setIsSendingMessage,
        flowChangerToken,
        activeSubmenu,
        setActiveSubmenu,
        selectedSidebarTab,
        setSelectedSidebarTab,
        showAnnouncementsModal,
        setShowAnnouncementsModal,
        showCreateGroupModal,
        setShowCreateGroupModal,
        AddMembersPanel,
        fetchBranch,
        setShowAddMembersPanel,
        showDeleteGroupModal,
        setShowDeleteGroupModal,
        showAddMemberModal,
        setShowAddMemberModal,
        handleAddMembersModal,
        handleAddMembersPanel,
        handleAnnouncementsClick,
        handleCreateGroupClick,
        handleDeleteGroupClick,
        toggleSettings,
        handleToggleSettings,
        fetchShifts,
        shift,
        setBranchData,
        branchData,
        staffDetail,
        fetchClientDetail,
        clientData,
        departments,
        setDepartments,
        fetchDepartments,
        currentPage,
        totalPages,
        totalRecords,
        rowsToShow,
        setCurrentPage,
        handlePrevious,
        handleNext,
        isLoading,
        setIsLoading,
        handleSelectChange,
        selectedStaffIds,
        setSelectedStaffIds,
        selectAll,
        setSelectAll,
        selectedStaff,
        setSelectedStaff,
        updatePagination,
        updateStaff,
        savePaymentData,
        setSavePaymentData,
        handleChangeBranch,
        handleChangeDepartment,
        selectBranch,
        selectDepartments,
        resetState,
        fetchRoles,
        attendance,
        attendanceTabDepartments,
        fine,
        overtime,
        setAttendance,
        setAttendanceTabDepartments,
        setFine,
        setOverTime,
        summaryDate,
        setSummaryDate,
        page,
        setPage,
        fetchDetail,
        setClientDetail,
        clientDetail,
        isOpen,
        setIsOpen,
        setTotalRecord,
        totalRecord,
        user,
        setUser,
        loadingClient,
        setLoadingStaffs,
        loadingStaffs,
        loadingRole,
        loadingDepartment,
        loadingBranch,
        leads,
        setleads,
        currentleadPage,
        setCurrentleadPage,
        totalleadPage,
        setTotalleadPage,
        totalleadRecords,
        setTotalleadRecords,
        pagelead,
        setleadPage,
        projectData,
        setProjectData,
        taskData,
        setTaskData,
        branchItem,
        setBranchItem,
        fetchLead,
        totalDepartmentPage,
        setTotalDepartmentPage
      }}
    >
      {children}
      <ToastContainer />
    </MainContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(MainContext);
};
